import React from "react";
import cataloguePdf from "../assets/Slimline Product Catalogue .pdf";

function Catalogue() {
  return (
    <div className="catalogue-page">

      <div className="catalogue-buttons">
        <a
          href={cataloguePdf}
          target="_blank"
          rel="noopener noreferrer"
          className="catalogue-view-btn"
        >
          View Catalogue
        </a>

        <a
          href={cataloguePdf}
          download="Slimline-Product-Catalogue.pdf"
          className="catalogue-download-btn"
        >
          Download Catalogue
        </a>
      </div>

      <div className="catalogue-pdf">
        <iframe
          src={`${cataloguePdf}#toolbar=1&navpanes=0&scrollbar=1`}
          title="Slimline Product Catalogue"
        />
      </div>

    </div>
  );
}

export default Catalogue;